import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardPHVListUX = (props: any) => {
    return(
      <div
        id="CardPHVListUX-div-0"
        style={{ margin: "10px" }}>
        <Form
          className="mini"
          id="CardPHVListUX-Form-1">
          <FormGroup
            id="CardPHVListUX-FormGroup-2">
            <FormField
              id="CardPHVListUX-FormField-3"
              style={{minWidth: "max-content"}}>
              <label
                id="CardPHVListUX-label-10"
                style={{margin: 0}}>
                {props.languageUX === "en" ? "Encounter type" : "ประเภทการรับบริการ"}
              </label>
              <div
                className="ui buttons mini"
                id="CardPHVListUX-div-15">
                
                <Button
                  id="CardPHVListUX-Button-16"
                  name="IPD"
                  onClick={props.onChangeEncounterType}
                  style={ {borderRight: "1px solid rgba(34,36,38,.15)", ...(props.encounterType?.includes("IPD")?{backgroundColor: "#56ccf2", color: "white"}:{})}}>
                  {props.languageUX === "en" ? "IPD" : "ผู้ป่วยใน"}
                </Button>
                <Button
                  id="CardPHVListUX-Button-17"
                  name="OPD"
                  onClick={props.onChangeEncounterType}
                  style={props.encounterType?.includes("OPD")?{backgroundColor: "#56ccf2", color: "white"}:{}}>
                  {props.languageUX === "en" ? "OPD" : "ผู้ป่วยนอก"}
                </Button>
              </div>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-4"
              inline={true}
              width={3}>
              <label
                id="CardPHVListUX-label-11"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Visit date" : "วันที่รับบริการ"}
              </label>
              <div
                id="CardPHVListUX-div-18"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardPHVListUX-DateTextBox-19"
                  onChange={props.onChangeDate?.("startDate")}
                  value={props.filter?.startDate|| ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-5"
              inline={true}
              width={3}>
              <label
                id="CardPHVListUX-label-12">
                {props.languageUX === "en" ? "To" : "ถึง"}
              </label>
              <div
                id="CardPHVListUX-div-20"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardPHVListUX-DateTextBox-21"
                  onChange={props.onChangeDate?.("endDate")}
                  value={props.filter?.endDate|| ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-6"
              inline={true}
              width={3}>
              <label
                id="CardPHVListUX-label-13">
                {props.languageUX === "en" ? "Division" : "แผนก"}
              </label>
              <Dropdown
                className="inline-label"
                clearable={true}
                fluid={true}
                id="CardPHVListUX-Dropdown-22"
                name="divisionId"
                onChange={props.onChangeFilter}
                options={props.divisionOptions || []}
                search={true}
                selection={true}
                style={{width: "100%", fontSize: "1em"}}
                value={props.filter?.divisionId || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-7"
              inline={true}
              width={3}>
              <label
                id="CardPHVListUX-label-14">
                {props.languageUX === "en" ? "Doctor" : "แพทย์"}
              </label>
              <div
                id="CardPHVListUX-div-23"
                style={{width: "100%"}}>
                {props.DoctorSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-31"
              inline={true}
              width={4}>
              <label
                id="CardPHVListUX-label-32">
                {props.languageUX === "en" ? "Dr.Order" : "รายการคำสั่งแพทย์"}
              </label>
              <div
                id="CardPHVListUX-div-35">
                {props.DoctorOrderOptions}
              </div>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-8">
              <label
                id="CardPHVListUX-label-30"
                style={{margin:0}}>
                {"\u00a0"}
              </label>
              <div
                id="CardPHVListUX-div-24">
                {props.ButtonSearch}
              </div>
            </FormField>
            <FormField
              id="CardPHVListUX-FormField-9">
              <label
                id="CardPHVListUX-label-29"
                style={{margin:0}}>
                {"\u00a0"}
              </label>
              <Button
                color="orange"
                id="CardPHVListUX-Button-25"
                onClick={props.onClickClear}
                size="mini">
                {props.languageUX === "en" ? "Clear" : "เคลียร์"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardPHVListUX-div-26">
          
          <Table
            data={props.encounterList || []}
            getTrProps={props.onGetTrProps}
            headers={props.headers}
            id="CardPHVListUX-Table-27"
            keys={props.keys}
            minRows={5}
            showPagination={false}
            style={{height: "200px"}}
            widths={props.widths}>
          </Table>
        </div>
        <div
          id="CardPHVListUX-div-28"
          style={{marginTop: "0.5rem", display: "flex", justifyContent: "flex-end"}}>
          {props.Pagination}
        </div>
      </div>
    )
}


export default CardPHVListUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Wed Oct 01 2025 12:42:05 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"10px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "mini"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทการรับบริการ",
          "valueEN": "Encounter type"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-10"
        },
        "style": {
          "type": "code",
          "value": "{margin: 0}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่รับบริการ",
          "valueEN": "Visit date"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-11"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "To"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-12"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "Division"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "Doctor"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui buttons mini"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยใน",
          "valueEN": "IPD"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-Button-16"
        },
        "name": {
          "type": "value",
          "value": "IPD"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeEncounterType"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": " {borderRight: \"1px solid rgba(34,36,38,.15)\", ...(props.encounterType?.includes(\"IPD\")?{backgroundColor: \"#56ccf2\", color: \"white\"}:{})}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยนอก",
          "valueEN": "OPD"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-Button-17"
        },
        "name": {
          "type": "value",
          "value": "OPD"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeEncounterType"
        },
        "style": {
          "type": "code",
          "value": "props.encounterType?.includes(\"OPD\")?{backgroundColor: \"#56ccf2\", color: \"white\"}:{}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 19,
      "name": "DateTextBox",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-DateTextBox-19"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"startDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.startDate|| \"\""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 21,
      "name": "DateTextBox",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-DateTextBox-21"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate?.(\"endDate\")"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.endDate|| \"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 6,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-Dropdown-22"
        },
        "name": {
          "type": "value",
          "value": "divisionId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", fontSize: \"1em\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.divisionId || \"\""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DoctorSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-24"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-Button-25"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickClear"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-26"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 27,
      "name": "Table",
      "parent": 26,
      "props": {
        "data": {
          "type": "code",
          "value": "props.encounterList || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetTrProps"
        },
        "headers": {
          "type": "code",
          "value": "props.headers"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-Table-27"
        },
        "keys": {
          "type": "code",
          "value": "props.keys"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.widths"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.Pagination"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.5rem\", display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-29"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-30"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPHVListUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการคำสั่งแพทย์",
          "valueEN": "Dr.Order"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-label-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DoctorOrderOptions"
        },
        "id": {
          "type": "value",
          "value": "CardPHVListUX-div-35"
        }
      },
      "seq": 35,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardPHVListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
